var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 38.098 38.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2601",
    "data-name": "Groupe 2601",
    transform: "translate(-3.5 -3.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2565",
    "data-name": "Groupe 2565",
    transform: "translate(3.5 15.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3755",
    "data-name": "Trac\\xE9 3755",
    d: "M41.274,34.031H36.521a.595.595,0,0,0,0,1.19h4.158v6.358a.591.591,0,0,0-.032.183v4.162H30.579a.6.6,0,0,0-.118.012l-.029.009a.591.591,0,0,0-.275.156l-.062.077-.007.009-.046.084-.009.018-.03.1,0,.016a.566.566,0,0,0-.013.126l.07,5.344H16.914V46.519a.6.6,0,0,0-.595-.595H6.221v-10.7H10.38a.595.595,0,1,0,0-1.19H5.626a.6.6,0,0,0-.595.595V41.58A.6.6,0,0,0,5,41.762v16.65a.6.6,0,0,0,.595.595H41.242a.6.6,0,0,0,.595-.595V46.7a.588.588,0,0,0,.032-.183V34.626A.6.6,0,0,0,41.274,34.031ZM6.189,57.818v-10.7h9.536v5.352a.6.6,0,0,0,.595.595H30.657a.6.6,0,0,0,.595-.6l-.07-5.344h9.466v10.7Z",
    transform: "translate(-4.386 -33.417)",
    fill: "#313d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3756",
    "data-name": "Trac\\xE9 3756",
    d: "M40.357,58.736H4.709A1.211,1.211,0,0,1,3.5,57.527V40.876a1.154,1.154,0,0,1,.031-.264V33.74A1.211,1.211,0,0,1,4.74,32.531H9.494a1.209,1.209,0,0,1,0,2.419H5.95v9.475h9.484a1.211,1.211,0,0,1,1.21,1.209v4.738h11.9l-.063-4.722a1.169,1.169,0,0,1,.025-.256l.1-.284.1-.173.125-.15a1.2,1.2,0,0,1,.562-.322l.063-.017a1.23,1.23,0,0,1,.238-.023h9.455V40.877a1.146,1.146,0,0,1,.032-.266V34.95H35.636a1.209,1.209,0,0,1,0-2.419h4.753A1.211,1.211,0,0,1,41.6,33.741V45.634a1.145,1.145,0,0,1-.032.266V57.527A1.211,1.211,0,0,1,40.357,58.736ZM5.918,56.318H39.147V46.843H30.918l.062,4.722a1.211,1.211,0,0,1-1.209,1.225H15.434a1.211,1.211,0,0,1-1.209-1.209V46.843H5.918Z",
    transform: "translate(-3.5 -32.531)",
    fill: "#313d57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2566",
    "data-name": "Groupe 2566",
    transform: "translate(14.147 3.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3757",
    "data-name": "Trac\\xE9 3757",
    d: "M38.792,25.218a.6.6,0,0,0,.595-.595V7.031l6.192,6.2a.595.595,0,0,0,.841-.841L39.213,5.174h0a.594.594,0,0,0-.838,0h0l-7.208,7.214a.595.595,0,0,0,.842.841l6.192-6.2V24.624A.6.6,0,0,0,38.792,25.218Z",
    transform: "translate(-30.376 -4.394)",
    fill: "#313d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3758",
    "data-name": "Trac\\xE9 3758",
    d: "M37.908,24.96A1.211,1.211,0,0,1,36.7,23.751V7.643l-5.143,5.148a1.209,1.209,0,0,1-1.711-1.709l7.263-7.266A1.237,1.237,0,0,1,38.7,3.8l.068.063,7.207,7.214a1.213,1.213,0,0,1,0,1.71,1.239,1.239,0,0,1-1.711,0L39.117,7.643V23.751A1.211,1.211,0,0,1,37.908,24.96Z",
    transform: "translate(-29.491 -3.522)",
    fill: "#313d57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.96713a7c6e39e3179effd5f3a62ccd40.svg";
export { ForwardRef as ReactComponent };